/**
 * Keyboard navigation utility for list-style dropdowns.
 *
 * Handles ArrowDown, ArrowUp (with wrapping), Enter selection, and Escape close.
 *
 * @param {KeyboardEvent} event
 * @param {Object} options
 * @param {number} options.highlightedIndex - Current highlighted index (-1 = none)
 * @param {number} options.itemCount - Total number of items in the list
 * @param {Function} options.onHighlight - Called with new index on arrow key
 * @param {Function} options.onSelect - Called with current index on Enter
 * @param {Function} options.onClose - Called on Escape
 * @returns {boolean} true if the event was handled
 */
export function handleListKeydown(event, { highlightedIndex, itemCount, onHighlight, onSelect, onClose }) {
  switch (event.key) {
    case "ArrowDown":
      event.preventDefault()
      onHighlight(Math.min(highlightedIndex + 1, itemCount - 1))
      return true

    case "ArrowUp":
      event.preventDefault()
      onHighlight(Math.max(highlightedIndex - 1, -1))
      return true

    case "Enter":
      if (highlightedIndex >= 0 && highlightedIndex < itemCount) {
        event.preventDefault()
        onSelect(highlightedIndex)
      }
      return true

    case "Escape":
      onClose()
      return true

    default:
      return false
  }
}
